import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "49",
  height: "15",
  viewBox: "0 0 49 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M45.1097 14.7985L42.9182 6.18098L40.5921 14.7647L40.6017 14.7985H36.8349L33.0697 0.0016077H36.8397L38.994 8.46434L41.2818 0.0016077H45.1194L49.0021 14.7985H45.1097ZM31.462 14.7985L27.7016 0.0016077H31.4716L35.232 14.7985H31.462ZM23.245 14.7985L21.073 6.25336L18.7274 14.7985H14.9702L12.0747 3.41937H8.78216L11.5233 14.7985H7.75324L5.00567 3.38058H0.883556L0.0234375 0H14.975L17.139 8.51617L19.4798 0H23.2498L25.4234 8.5401L26.9331 3.0703L28.5311 9.34091L27.0006 14.796L23.245 14.7985Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }